import { Asterisk } from "lucide-react";

const WORDS = ["Kashmir", "Ladakh", "Alibaug", "Jaipur", "Rishikesh", "Kerala", "Manali", "Bali", "Maldives", "Sri Lanka", "Dubai"];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {WORDS.map((w, i) => (
      <span key={w} className="flex items-center">
        <span className={`px-6 font-display text-5xl sm:text-7xl font-extrabold tracking-tight ${i % 2 ? "text-outline" : "text-ink"}`}>{w}</span>
        <Asterisk className="h-8 w-8 sm:h-10 sm:w-10 text-ink" strokeWidth={3} />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div className="overflow-hidden py-4">
    <section className="relative overflow-hidden bg-go py-6 sm:py-8 -rotate-1 scale-[1.03] border-y-2 border-ink" data-testid="editorial-marquee" aria-label="Destinations">
      <div className="flex w-max animate-marquee">
        <Row /><Row />
      </div>
    </section>
  </div>
);
